import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Plus } from "lucide-react";
import { toast } from "sonner";

export default function QuoteRequests() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ lines: [{ product_id: "", qty: 1 }], remarks: "" });

  const load = async () => { const { data } = await api.get("/dealer/quote-requests"); setItems(data); };
  useEffect(() => { load(); }, []);

  const addLine = () => setForm({ ...form, lines: [...form.lines, { product_id: "", qty: 1 }] });
  const updLine = (i, k, v) => setForm({ ...form, lines: form.lines.map((line, idx) => idx === i ? { ...line, [k]: k === "qty" ? parseInt(v || "0", 10) : v } : line) });
  const save = async () => {
    try { await api.post("/dealer/quote-requests", form); toast.success("Quote request sent"); setOpen(false); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="dealer-quotes">
      <div className="flex items-start justify-between">
        <div><h1 className="font-display text-2xl sm:text-3xl font-black">Quotation requests</h1><p className="text-muted-foreground">Request custom pricing for bulk or special-finish orders.</p></div>
        <Button onClick={() => setOpen(true)} data-testid="dquote-create-btn"><Plus className="w-4 h-4 mr-1" /> Request quote</Button>
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        {items.map((q) => (
          <Card key={q.id} data-testid={`dquote-${q.id}`}>
            <CardContent className="p-4 space-y-2">
              <div className="flex items-center justify-between"><div className="font-mono text-xs text-muted-foreground">{q.id.slice(0, 8)}</div><Badge>{q.status}</Badge></div>
              <div className="text-sm">{q.lines.length} line(s) — {q.lines.map((line) => `${line.title} × ${line.qty}`).join(", ")}</div>
              {q.remarks && <div className="text-xs text-muted-foreground">{q.remarks}</div>}
              <div className="font-mono text-[10px] text-muted-foreground">{new Date(q.created_at).toLocaleString()}</div>
            </CardContent>
          </Card>
        ))}
        {items.length === 0 && <div className="col-span-2 text-center text-muted-foreground py-10">No quote requests yet.</div>}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Request quote</DialogTitle></DialogHeader>
          <div className="space-y-3">
            {form.lines.map((line, i) => (
              <div key={i} className="grid grid-cols-3 gap-2">
                <Input className="col-span-2" placeholder="Product ID (copy from catalogue)" value={line.product_id} onChange={(e) => updLine(i, "product_id", e.target.value)} data-testid={`dquote-line-${i}`} />
                <Input type="number" placeholder="Qty" value={line.qty} onChange={(e) => updLine(i, "qty", e.target.value)} />
              </div>
            ))}
            <Button size="sm" variant="outline" onClick={addLine}><Plus className="w-4 h-4 mr-1" /> Add line</Button>
            <div><Label>Remarks</Label><Input value={form.remarks} onChange={(e) => setForm({ ...form, remarks: e.target.value })} placeholder="Bulk order, special finish, expected delivery, etc." /></div>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button><Button onClick={save} data-testid="dquote-save">Send</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
